<template>
  <div class="h-100">
    <router-view />
    <vue-confirm-dialog></vue-confirm-dialog>
    <color-switcher />
  </div>
</template>

<script>
import ColorSwitcher from './components/Common/ColorSwitcher'

export default {
  components: {
    'color-switcher': ColorSwitcher
  }
}
</script>
